// AROMA NET — Panduan Aplikasi (structured content)
// Source of truth: Buku_Panduan_Aplikasi_AROMA_NET.docx (Feb 2026).
// Static structured content — halaman /panduan tidak membaca DOCX
// runtime. Ini adalah representasi 1:1 dari isi DOCX; jangan menambah
// klaim fitur di luar DOCX.
//
// Setiap chapter memiliki `id` (dipakai untuk anchor #hash) yang stabil.

export const PANDUAN_CHAPTERS = [
  {
    id: "pendahuluan",
    title: "Pendahuluan",
    sections: [
      {
        heading: "Tujuan",
        items: [
          "Panduan ini menjadi acuan penggunaan aplikasi operasional AROMA NET untuk administrasi, absensi, DINAS, rekap absensi, Manajemen Pekerjaan/Tiket, notifikasi, dan Billing.",
        ],
      },
      {
        heading: "Prinsip",
        items: [
          "Gunakan akun sesuai role, jaga kredensial, input data sesuai kondisi sebenarnya, dan lakukan perubahan historis hanya sesuai kewenangan.",
        ],
      },
    ],
  },
  {
    id: "role-dan-hak-akses",
    title: "Role dan Hak Akses",
    sections: [
      {
        heading: "ADMIN",
        items: [
          "Akses administrasi paling luas. Mengelola DINAS, Rekap Absensi, koreksi administratif, dan fungsi Billing yang dibatasi untuk Admin. Bulk Bayar Billing hanya untuk Admin.",
        ],
      },
      {
        heading: "KOORDINATOR",
        items: [
          "Akses mengikuti scope wilayah. Dapat mengelola DINAS sesuai kewenangan dan melihat Rekap Absensi sesuai RBAC.",
        ],
      },
      {
        heading: "TEKNISI",
        items: [
          "Fokus pada pekerjaan operasional dan absensi pribadi. Dapat melihat DINAS yang ditugaskan kepadanya dan tidak dapat membuat DINAS.",
        ],
      },
      {
        heading: "KOLEKTOR",
        items: [
          "Mengelola penagihan sesuai customer yang ditugaskan. Akses Billing mengikuti RBAC.",
        ],
      },
    ],
  },
  {
    id: "navigasi-aplikasi",
    title: "Navigasi Aplikasi",
    sections: [
      {
        heading: "Menu Utama",
        items: [
          "Dashboard Utama untuk ringkasan.",
          "Absensi & Lembur untuk attendance/overtime.",
          "Dinas untuk assignment kerja luar kantor.",
          "Rekap Absensi untuk analisis dan export.",
          "Manajemen Pekerjaan/Tiket untuk pekerjaan teknisi.",
          "Billing untuk customer, invoice, pembayaran, dan penagihan.",
        ],
      },
      {
        heading: "Notifikasi",
        items: [
          "Notification Bell menampilkan notifikasi internal.",
          "Web Push tersedia bila browser/perangkat sudah memberikan permission dan subscription.",
        ],
      },
    ],
  },
  {
    id: "absensi",
    title: "Absensi & Lembur",
    sections: [
      {
        heading: "Check-in / Check-out",
        items: [
          "Check-in dan check-out mengikuti attendance engine existing.",
          "Status meliputi HADIR, TERLAMBAT, ALPA, IZIN, SAKIT, dan CUTI.",
          "Status administratif IZIN, SAKIT, dan CUTI mengikuti workflow pengajuan/persetujuan.",
          "Status yang telah disetujui tidak boleh ditimpa secara sembarangan.",
        ],
      },
      {
        heading: "Lembur",
        items: [
          "Lembur adalah workflow terpisah.",
          "DINAS tidak otomatis berarti lembur.",
        ],
      },
      {
        heading: "GPS",
        items: [
          "Lokasi GPS digunakan sebagai validasi/evidence sesuai lokasi kerja yang diizinkan.",
        ],
      },
    ],
  },
  {
    id: "dinas",
    title: "DINAS / Kerja di Lokasi Lain",
    sections: [
      {
        heading: "Konsep DINAS",
        items: [
          "Konsep DINAS adalah konteks/lokasi kerja, bukan status absensi baru.",
          "Status tetap HADIR atau TERLAMBAT sesuai engine.",
        ],
      },
      {
        heading: "Membuat DINAS",
        items: [
          "Admin/Koordinator yang berwenang menentukan tujuan, keperluan, periode, peserta, dan target GPS.",
          "Satu DINAS dapat memiliki banyak peserta.",
          "Multi-day DINAS memiliki start_date dan end_date.",
          "Setiap hari dalam periode tetap merupakan hari kerja/attendance harian.",
        ],
      },
      {
        heading: "GPS DINAS",
        items: [
          "Saat DINAS aktif, target GPS DINAS menggantikan HQ/cabang untuk validasi.",
          "GPS peserta tidak mengubah target.",
        ],
      },
      {
        heading: "Notifikasi DINAS",
        items: [
          "Assignment baru memakai duty_assigned.",
          "Perubahan penting dapat menghasilkan duty_updated.",
          "Peserta yang dihapus dapat menerima duty_unassigned.",
        ],
      },
      {
        heading: "Cancel vs Selesai",
        items: [
          "active=false digunakan untuk pembatalan/nonaktif.",
          "DINAS yang sudah melewati end_date selesai secara alami dan tidak membutuhkan auto-close.",
        ],
      },
      {
        heading: "Rekap Card DINAS",
        items: [
          "Menampilkan statistik Hadir, Terlambat, Alpa, Izin, Sakit, Cuti.",
          "Card/tombol Lihat Rekap membuka Rekap Absensi terfilter duty_id dan periode.",
        ],
      },
    ],
  },
  {
    id: "rekap-absensi",
    title: "Rekap Absensi",
    sections: [
      {
        heading: "Filter",
        items: [
          "Tersedia filter Periode, Role, User, Lokasi, Wilayah, DINAS, dan Status.",
        ],
      },
      {
        heading: "Source of Truth",
        items: [
          "Filter DINAS memakai attendance.duty_id.",
          "Filter Kantor/non-DINAS memakai attendance tanpa duty_id.",
          "Filter Wilayah memakai users.wilayah_ids dan tetap mengikuti RBAC.",
        ],
      },
      {
        heading: "Quick-Jump",
        items: [
          "Bulan Ini = tanggal 1 sampai hari ini.",
          "Bulan Lalu = seluruh bulan sebelumnya.",
          "7 Hari Terakhir = hari ini + 6 hari sebelumnya.",
          "30 Hari Terakhir = hari ini + 29 hari sebelumnya.",
          "Custom = input manual.",
        ],
      },
      {
        heading: "Preview Count",
        items: [
          "Dropdown Role, User, Lokasi, Wilayah, DINAS, dan Status dapat menampilkan jumlah data.",
          "Count mengikuti filter sesuai mekanisme facet.",
        ],
      },
      {
        heading: "Header Periode",
        items: [
          "Top-bar menampilkan periode yang benar-benar diterapkan, bukan draft.",
          "Contoh: Rekap Absensi · Bulan Ini · 1–21 September 2026.",
        ],
      },
      {
        heading: "Export",
        items: [
          "Excel dan PDF mengikuti filter/periode yang diterapkan.",
          "Filter Wilayah dan DINAS ikut tercermin pada metadata/sub-heading.",
        ],
      },
    ],
  },
  {
    id: "tiket",
    title: "Manajemen Pekerjaan / Tiket",
    sections: [
      {
        heading: "Lokasi Tiket",
        items: [
          "Untuk tiket baru, lokasi belum dianggap confirmed hanya karena map memiliki titik default.",
          "Pengguna harus melakukan interaksi konfirmasi sesuai LocationPicker.",
        ],
      },
      {
        heading: "Filter",
        items: [
          "Manajemen Pekerjaan mendukung filter Status, Prioritas, Jenis, Wilayah, PIC, pencarian, dan tanggal sesuai halaman.",
        ],
      },
      {
        heading: "Jenis Pekerjaan",
        items: [
          "Reference yang digunakan mencakup PSB, REP, REL, UPG, dan NET.",
        ],
      },
      {
        heading: "Export / Rekap",
        items: [
          "Export mengikuti filter aktif.",
          "Monthly PDF recap merekap tiket DONE sesuai fungsi yang tersedia.",
        ],
      },
    ],
  },
  {
    id: "billing",
    title: "Billing",
    sections: [
      {
        heading: "Feature Freeze",
        items: [
          "Billing V1 memiliki business rule tersendiri dan diperlakukan sebagai feature freeze.",
          "Jangan mengubah logic tanpa keputusan pengembangan khusus.",
        ],
      },
      {
        heading: "Status Layanan",
        items: [
          "AKTIF dapat menghasilkan invoice.",
          "ISOLIR dan BERHENTI tidak menghasilkan invoice baru.",
        ],
      },
      {
        heading: "Invoice / Payment",
        items: [
          "Invoice mengikuti periode dan status pembayaran.",
          "Invoice LUNAS dapat memiliki Kwitansi.",
          "PDF Invoice dan Kwitansi menggunakan template final.",
        ],
      },
      {
        heading: "Collector",
        items: [
          "Collector melihat tagihan sesuai assignment.",
          "Tagihan Saya menampilkan outstanding invoice dalam scope.",
          "Bulk Bayar adalah fungsi Admin.",
        ],
      },
      {
        heading: "Auto-Isolir",
        items: [
          "Auto-Isolir merupakan engine terpisah yang dikendalikan konfigurasi dan kewenangan Admin.",
        ],
      },
    ],
  },
  {
    id: "notifikasi",
    title: "Notifikasi & Web Push",
    sections: [
      {
        heading: "Attendance",
        items: [
          "Notifikasi dapat mencakup approval/rejection request, PERLU_VERIFIKASI, ALPA finalization, digest koordinator, dan overtime.",
        ],
      },
      {
        heading: "DINAS",
        items: [
          "Notifikasi DINAS mencakup duty_assigned, duty_updated, dan duty_unassigned.",
        ],
      },
      {
        heading: "Web Push",
        items: [
          "Push membutuhkan dukungan browser dan permission.",
          "Kegagalan push tidak boleh menggagalkan proses utama; in-app notification tetap menjadi jalur utama.",
        ],
      },
    ],
  },
  {
    id: "prosedur-operasional",
    title: "Prosedur Operasional",
    sections: [
      {
        heading: "Sebelum Kerja",
        items: [
          "Pastikan DINAS sudah dibuat, tujuan/tanggal/peserta/GPS benar, dan peserta menerima notifikasi.",
        ],
      },
      {
        heading: "Saat Kerja",
        items: [
          "Peserta check-in di lokasi yang ditentukan. Untuk DINAS, gunakan lokasi DINAS.",
          "Lakukan check-out sesuai workflow.",
        ],
      },
      {
        heading: "Setelah Kegiatan",
        items: [
          "Periksa card DINAS, statistik attendance, lalu gunakan Lihat Rekap untuk detail per hari/per user atau export untuk arsip.",
        ],
      },
    ],
  },
  {
    id: "troubleshooting",
    title: "Troubleshooting",
    sections: [
      {
        heading: "Tidak Bisa Check-in DINAS",
        items: ["Periksa tanggal aktif, peserta, target GPS, dan radius."],
      },
      {
        heading: "DINAS Tidak Terlihat",
        items: ["Periksa periode, peserta, role, dan scope RBAC."],
      },
      {
        heading: "Rekap Kosong",
        items: [
          "Periksa periode dan kombinasi filter.",
          "Gunakan preview count untuk melihat ketersediaan data.",
        ],
      },
      {
        heading: "Push Tidak Muncul",
        items: [
          "Periksa permission Notification dan subscription Web Push.",
          "In-app Notification Bell tetap dapat digunakan.",
        ],
      },
      {
        heading: "Data Lama Tanpa duty_id",
        items: [
          "Attendance lama tetap valid dan diperlakukan sebagai non-DINAS/Kantor pada filter.",
        ],
      },
    ],
  },
  {
    id: "tata-kelola",
    title: "Tata Kelola & Keamanan",
    sections: [
      {
        heading: "Keamanan",
        items: [
          "Gunakan RBAC, jangan berbagi akun, jangan memanipulasi GPS, dan jangan mengubah data historis tanpa alasan operasional.",
        ],
      },
      {
        heading: "Stabilitas",
        items: [
          "Attendance SSoT, ALPA finalizer, auto-settle, overtime, Billing V1, dan Ticket harus diperlakukan sebagai modul stabil.",
          "Perubahan besar harus melalui pengembangan dan regression test.",
        ],
      },
    ],
  },
  {
    id: "fitur-belum-digunakan",
    title: "Fitur yang Belum Digunakan",
    sections: [
      {
        heading: "Tidak Termasuk Prosedur Saat Ini",
        items: [
          "Auto-close DINAS berbasis scheduler, QR code DINAS, auto-suggest periode, dan tombol Salin Header belum digunakan.",
          "Fitur baru di luar implementasi resmi tidak dianggap sebagai prosedur operasional sampai diterapkan.",
        ],
      },
    ],
  },
  {
    id: "checklist-harian",
    title: "Checklist Harian Admin/Koordinator",
    sections: [
      {
        heading: "Checklist",
        items: [
          "Periksa notifikasi penting.",
          "Pastikan DINAS hari berjalan benar.",
          "Pastikan peserta sesuai.",
          "Periksa attendance PERLU_VERIFIKASI bila ada.",
          "Gunakan filter Rekap sesuai kebutuhan.",
          "Export Excel/PDF jika diperlukan.",
          "Jangan mengubah Billing V1/Ticket tanpa prosedur pengembangan.",
        ],
      },
    ],
  },
];
